// extracted by mini-css-extract-plugin
export default {"centered":"TableProductBody_centered__AUKYi","message":"TableProductBody_message__9EFV7"};